export const KG = 'KG'
export const LB = 'LB'
